import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faBluesky, faGoogleScholar } from '@fortawesome/free-brands-svg-icons';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { SiHuggingface } from "react-icons/si";

interface SocialLinksProps {
    className?: string;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ className = '' }) => {
    return (
        <div className={`flex flex-row space-x-5 justify-center items-center ${className}`}>
            <a href="https://github.com/rifqifarhansyah" alt="Rifqi Github" title="Github">
                <FaGithub className='text-textGrey hover:text-textRed' />
            </a>
            <a href="https://huggingface.co/rifqifarhansyah" alt="Rifqi HuggingFace" title="HuggingFace">
                <SiHuggingface className='text-textGrey hover:text-textRed' />
            </a>
            <a href="https://www.linkedin.com/in/mohammadrifqifarhansyah/" alt="Rifqi Linkedin" title="Linkedin">
                <FaLinkedin className='text-textGrey hover:text-textRed' />
            </a>
            <a href="https://twitter.com/rifqifrhnsyah" alt="Rifqi X" title="X">
                <FontAwesomeIcon className='text-textGrey hover:text-textRed' icon={faXTwitter} />
            </a>
            <a href="https://bsky.app/profile/rifqifarhansyah.bsky.social" alt="Rifqi Bluesky" title="Bluesky">
                <FontAwesomeIcon className='text-textGrey hover:text-textRed' icon={faBluesky} />
            </a>
            <a href="https://scholar.google.com/citations?hl=en&authuser=2&user=yEFsnVUAAAAJ" alt="Rifqi Google Scholar" title="Google Scholar">
                <FontAwesomeIcon className='text-textGrey hover:text-textRed' icon={faGoogleScholar} />
            </a>
        </div>
    );
};

export default SocialLinks;